import { render, staticRenderFns } from "./Select2Items.vue?vue&type=template&id=f517a4a6&"
import script from "./Select2Items.vue?vue&type=script&lang=js&"
export * from "./Select2Items.vue?vue&type=script&lang=js&"
import style0 from "./Select2Items.vue?vue&type=style&index=0&id=f517a4a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports